import { useQuery } from '@tanstack/react-query';
import { invitationPreviewSchema } from '@/api/hooks/useInvitationPreview';
import { apiOrigin, resolveBackendUrl } from '@/api/apiOrigin';
import { parseEnvelope } from '@/api/envelope';

export function usePublicInvitationPreview(token: string | null) {
  return useQuery({
    queryKey: ['public-accountant-invitation-preview', token],
    enabled: Boolean(token),
    queryFn: async () => {
      const response = await fetch(resolveBackendUrl('/api/accountant-invitations/preview', apiOrigin), {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ token }),
      });
      if (!response.ok) throw new Error(`Invitation preview failed: ${response.status}`);
      return parseEnvelope(invitationPreviewSchema, await response.json()).data;
    },
  });
}
